import React from "react";
import { Input, InputNumber } from "antd";
import "./app_text_field.css";
import UtilBloc from "../../../bloc/util_bloc";
import AppTextFieldConfig from "./app_text_field_config";
import AppFieldError from "../form/app_field_error/app_field_error";
import NumberFormat from "react-number-format";

const { TextArea } = Input;

class AppTextField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastValue: 0,
            error: "",
        };
    }


    stateError() { return this.state.error };

    propType() { return this.props.type };
    propPlaceholder() { return this.props.placeholder };
    propValue() { return this.props.value };
    propMaxLength() { return this.props.maxLength };
    propShowCount() { return this.props.showCount };
    propTitle() { return this.props.title };
    propPrefix() { return this.props.prefix };
    propSuffix() { return this.props.suffix };
    propMultiline() { return this.props.multiline || false };
    propErrorLabelGetter() { return this.props.errorMessage };
    propErrorIndicator() { return this.props.error || false };
    propOnBlur() { return this.props.onBlur };
    propCompulsory() { return this.props.compulsory };
    propValidationMode() { return this.props.validationMode };

    propOnValidation(value) { 
        if(this.props.onValidate){
            this.setState({error: this.props.onValidate(value)})
        }
    };

    onTextBlur(value) {
        console.log(value)
        if (this.propCompulsory() == AppTextFieldConfig.compulsory.true && this.propValidationMode() == AppTextFieldConfig.validationMode.onBlur) {
            this.onTextBlurValidate(value);
        }
        this.onBlurListener(value);
    }


    //Validate text on blur
    onTextBlurValidate(value) {
        let error = "";
        this.setState({ value: value, error: error });
        error = this.onValidateListener(value, AppTextFieldConfig.validationMode.onBlur)
        this.setState({
            error: error
        })
    }

    //Text on blur (complete/lose focus) listener
    onBlurListener(value) {
        if (this.propOnBlur()) this.propOnBlur()(value);
    }

    onTextChange(val) {
        this.props.onChange(val);
    }
    //On get error label
    onGetErrorLabel(error) {
        return this.onGetErrorLabelListener(error);
    }

    //Process error label getter for display
    onGetErrorLabelListener(error) {
        return this.propErrorLabelGetter() ? this.propErrorLabelGetter()(error) : error;
    }


    renderTextField() {
        if (this.propMultiline()) {
            return (
                <TextArea
                    rows={4}
                    disabled={this.props.disabled || false}
                    style={{ border: this.propErrorIndicator() || this.state.error  ? '1px solid #FC5A5A' : '1px solid rgba(224, 224, 224, 1)'}}
                    placeholder={this.propPlaceholder()}
                    value={this.propValue()}
                    showCount={this.propShowCount()}
                    maxLength={this.propMaxLength()}
                    onChange={(e) => {
                        const text = e.target.value
                        this.onTextChange(text);
                    }}
                />
            )
        } else {
            return (
                <Input
                    placeholder={this.propPlaceholder()}
                    style={{
                        height: "48px",
                        border: this.propErrorIndicator() || this.state.error  ? '1px solid #FC5A5A' : '1px solid rgba(224, 224, 224, 1)'
                    }}
                    showCount={this.propShowCount()}
                    maxLength={this.propMaxLength()}
                    value={this.propValue()}
                    disabled={this.props.disabled || false}
                    prefix={this.propPrefix()}
                    suffix={this.propSuffix()}
                    defaultValue={this.propValue()}
                    onBlur={(e) => {
                        this.onTextBlur(e.target.value);
                    }}
                    onChange={(e) => {
                        const text = e.target.value;
                        this.propOnValidation(text);
                        if (this.propMaxLength()) {
                            if (text.length <= this.propMaxLength()) {
                                this.onTextChange(text);
                            }
                        } else {
                            if (text.length <= 250) {
                                this.onTextChange(text);
                            }
                        }
                    }}
                />
            )
        }

    }

    renderNumberField = () => {
        return (
            <Input
                type="number"
                placeholder={this.propPlaceholder()}
                style={{
                    height: "48px",
                    justifySelf: 'center',
                    alignContent: 'center',
                    border: this.propErrorIndicator() || this.state.error  ? '1px solid #FC5A5A' : '1px solid rgba(224, 224, 224, 1)'
                }}
                min={0}
                controls={false}
                value={this.propValue()}
                disabled={this.props.disabled || false}
                maxLength={this.propMaxLength()}
                prefix={this.propPrefix()}
                suffix={this.propSuffix()}
                onChange={(e) => {
                    const text = e.target.value
                    this.propOnValidation(text);
                    this.onTextChange(text);
                }}
            />
        )
    }

    renderCreditCardField = () => {
        return (
            <Input
                // type="password"
                placeholder={this.propPlaceholder()}
                style={{
                    height: "48px",
                    border: this.propErrorIndicator() || this.state.error ? '1px solid #FC5A5A' : '1px solid rgba(224, 224, 224, 1)'
                }}
                value={this.propValue()}
                disabled={this.props.disabled || false}
                maxLength={this.propMaxLength()}
                prefix={this.propPrefix()}
                suffix={this.propSuffix()}
                onChange={(e) => {
                    let text = e.target.value.replace(/\D/g, '');
                    if (text.length < 17) {
                        text = text.replace(/(\d{4})/g, '$1 ');
                        if (text.endsWith(' ')) {
                            text = text.slice(0, -1);
                        }
                    }
                    
                    this.propOnValidation(text);
                    this.onTextChange(text);
                }}
            />
        )
    }

    render() {
        return (
            <div className="">
                <div className="input_title my-1 mb-2">
                    {this.propTitle()}
                </div>
                {this.propType() === 'text' &&
                    this.renderTextField()
                }
                {this.propType() === 'number' &&
                    this.renderNumberField()
                }
                {this.propType() === 'credit_card' &&
                    this.renderCreditCardField()
                }
                <div style={{ display: "block", width: "100%", height: '15px' }}>
                    {
                        (this.propErrorIndicator() || this.state.error) &&
                        <AppFieldError
                            text={this.propErrorLabelGetter()}
                        />
                    }
                </div>


            </div>
        );
    }
}

export default AppTextField;
